class MarqueeText extends HTMLElement {
  connectedCallback() {
    this._calculateDuration(this.querySelector('.announcement-bar__inner'));
  }

  _calculateDuration(entries) {
    let scrollingSpeedMobile = parseInt(entries.getAttribute('data-scroll-speed-mobile'));
    let scrollingSpeed       = parseInt(entries.getAttribute('data-scroll-speed'));

    if (scrollingSpeedMobile) {
      if (window.matchMedia('(max-width: 560px)').matches) {
        scrollingSpeed = scrollingSpeedMobile;
      }
    }

    let contentWidth = entries.offsetWidth,
      slowFactor = (1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375));

    entries.style.setProperty('--marquee-animation-duration', `${(scrollingSpeed * slowFactor * entries.querySelector('span').clientWidth / contentWidth).toFixed(3)}s`);
  }
}

try {
  window.customElements.define('marquee-text', MarqueeText);
} catch(e) {}